import React from 'react';
import {
  Flex, Box, IconButton, Menu, MenuButton, MenuList, MenuItem, Avatar, Text, HStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaSignOutAlt } from 'react-icons/fa';

const Navbar = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <Flex
      as="nav"
      h="64px"
      px={{ base: 4, md: 6 }}
      bg="white"
      borderBottom="1px solid"
      borderColor="slate.100"
      boxShadow="nav"
      justify="space-between"
      align="center"
    >
      <HStack spacing={3}>
        <IconButton
          aria-label="Open Menu"
          icon={<FaBars />}
          onClick={onMenuClick}
          display={{ base: 'flex', md: 'none' }}
          variant="ghost"
          color="slate.600"
          borderRadius="lg"
        />
        <Box display={{ base: 'none', md: 'block' }}>
          <Text fontSize="sm" color="slate.500">Welcome back</Text>
          <Text fontSize="md" fontWeight="600" color="slate.800" fontFamily="heading">
            Operations Dashboard
          </Text>
        </Box>
      </HStack>

      <Menu>
        <MenuButton>
          <HStack spacing={3} cursor="pointer">
            <Box textAlign="right" display={{ base: 'none', sm: 'block' }}>
              <Text fontSize="sm" fontWeight="600" color="slate.700">Admin</Text>
              <Text fontSize="xs" color="slate.400">Terracool</Text>
            </Box>
            <Avatar size="sm" name="Admin" bg="brand.500" color="white" />
          </HStack>
        </MenuButton>
        <MenuList borderRadius="xl" borderColor="slate.100" boxShadow="card" py={2}>
          <MenuItem borderRadius="md" _hover={{ bg: 'slate.50' }} onClick={handleLogout}>
            <HStack>
              <FaSignOutAlt />
              <Text>Logout</Text>
            </HStack>
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default Navbar;
